module.exports = __webpack_public_path__ + "static/media/paywayLastStep.3f760396.svg";